export const APP_ROUTES = {
  LOGIN: "/",
  HOME: "/dashboard",
  CHECKOUT: "/checkout",
  CONSULTDOCTOR: "/consultdoctor",
  DOCTORDETAILS: "/doctordetail",
  PRIVACYPOLICY: "/privacypolicy",
  TERMSOFUSE: "/termsofuse",
  REFUNDPOLICY: "/refundpolicy",
  // newly added routes from patient app
  MYAPPOINMENTS: "/myappointments",
  MYPROFILE: "/myprofile",
  FAMILYMEMBERS: "/familymembers",
  MEDICALRECORDS: "/medicalrecords",
  MEDICALHISTORY: "/medicalhistory",
  MYPRESCRIPTION: "/myprescription",
  MYVITALS: "/myvitals",
  MYREPORTS: "/myreports",
  MYLABREPORTS: "/mylabreports",
  PAYMENTS: "/payments",
  SETTINGS: "/settings",
  VIDEOCALL: "/videocall",
  LABPRSCRIPTION: "/sp/v1/l/:id",
  PHARMACYPRSCRIPTION: "/sp/v1/p/:id",
  LOGOUT: "/logout",
  PrescriptionTemplate: "/PrescriptionTemplate",
  FORGOTPASSWORD: "/forgotpassword",
  SHARECALLPATIENT: "/sharecallpatient",
  PHONEPEPAYMENT: "/phonepepayment/:transactionId",
  CARTPAGEPAYMENT: "/cartpagepayment/:transactionId",
  PHONEPEPAYMENT1: "/phonePeResponse1/paymentRedirectDetails/:status",
  HEALTHSUMMARY: "/healthsummary",
  PHRACCESS: "/PHR-ACCESS/:id",
  HOSPITALSERVICE: "/hospitalservice",
  MEDICINES: "/medicines",
  MEDICINECART: "/medicinecart",
  PRODUCTDETAILS: "/productdetails",
  LABTESTS: "/labtests",
  CHECKUP: "/checkup",
  CHECKUPALL: "/checkupall",
  TESTDETAILS: "/testdetails",
  TESTCART: "/testcart",
  CONSENT: "/consent",
  DASHBOARDNEW: "/dashboard",
  ORDERHISTORY: "/orderhistory",
  GIVECONSENT: "/v1/cons/",
  BOOKMEDICINE: "/bookmedicine",
  BOOKLABTEST: "/booklabtest",
  BOOKAPPOINTMENT: "/bookappointment",
  DOCTORDETAIL: "/doctorprofile",
  MYCART: "/mycart",
  MEDICINEDETAILS: "/medicinedetails",
  LABTESTDETAILS: "/labtestdetails",
  CART: "/cart",
  NOTIFICATION: "/notification",
  DEVICES: "/devices",
  PROCEDURELIST: "/procedurelist",
  //Direct Link Routes
  MOBILECONSENT: "/v1/cons/pat/",
  SHAREPRSCRIPTION: "/sp/v1",
  LABREPORTLINK: "/v1/ld",
  SHAREPAYMENTLINK: "/s/v1",
  SHARECALL: "/vc",
  HEALTHPLANS: "/healthplans",
  MEMBERSHIP: "/membership",
  JOINMEMBERSHIP: "/joinmembership",
  PATIENTMBERSHIP: "/patientmembership",
  DIETPLAN: "/dietplan",
  BOOKDEMO: "/bookdemo",
  MEDICINEREMINDER: "/medicinereminder",
  BLOG: "/blog",
  BLOGDETAIL: "/blog/:id",
  PATIENTREGISTRATION: "/patients/registration",
  //Privacy and terms direct links
  DOXPRIVACYPOLICY: "/mobile-app/privacy-policy",
  DOXTERMSOFUSE: "/mobile-app/terms-of-use",
  DOXREFUNDPOLICY: "/mobile-app/refund-policy",

  // footercontent
  TELEMEDICINE: "/telemedicine",
  HEALTHRECORDS: "/healthrecords",
  DIAGNOSTICS: "/diagnostics",
  INTEGRATIONS: "/integrations",

  // footercontent for patient
  FINDCARE: "/findcare",
  APPOINTMENTS: "/appointments",
  LABTEST: "/labtest",
  FAMILYCARE: "/familycare",
  PHARMACY: "/pharmacy",
 //enrollment forms for admin only
  DOCTORENROLLMENTFORM:`/doctor-enrollment-form`,
  RPMENROLLMENTFORM:`/rpm-enrollment-form`,
  // footercontent for Healthcare Professionals
  EHR: "/ehr",
  SCHEDULING: "/scheduling",
  EPRESCRIPTION: "/eprescription",
  BILLING: "/billing",
  VIRTUALCARE: "/virtualcare",

  // footercontent for company
  CONTACT: "/contact",
  CAREERS: "/careers",
  PRESS: "/press",
  ABOUTDOXON: "/aboutdoxzon",
  PARTNERS: "/partners",

  // footercontent for Trust
  HELPCENTER: "/helpcenter",
  SECURITY: "/security",
  SYSTEMSTATUS: "/systemstatus",
  COMPLIANCE: "/compliance",
  
};
